/* eslint-disable indent */

import styled, { css } from 'styled-components';
import { Flex, mediaMixin, spaceMixin, Spacer, token, TooltipPopper, TriggerText } from '@zillow/constellation';

const defaultImageWidth = '144px';

export const StyledSpacer = styled(Spacer)`
  margin-right: ${spaceMixin('xs')};
`;

export const StyledFlex = styled(Flex)`
  flex-direction: row;
`;

export const StyledDesktopOnlyDiv = styled(Spacer)`
  display: none;
  background-color: ${token('colors.gray200')};
  text-align: center;
  overflow: hidden;
  height: 156px;
  border-radius: ${spaceMixin(0.5)};

  ${mediaMixin(
    'lg',
    css`
      display: block;
      ${(props: { isMultipleLeases?: boolean }) =>
        props.isMultipleLeases &&
        css`
          display: none;
        `}
      width: auto;
      height: 156px;
    `,
  )}

  .LeasePreview, .LeasePreviewPlaceholder {
    width: ${defaultImageWidth};
    margin-top: ${spaceMixin('sm')};
    background-color: ${token('colors.gray200')};

    ${mediaMixin(
      'md',
      css`
        width: 108px;
      `,
    )}
    ${mediaMixin(
      'lg',
      css`
        width: ${defaultImageWidth};
      `,
    )}
  }

  .LeasePreview {
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1);
  }
`;

export const StyledTooltipPopper = styled(TooltipPopper)`
  vertical-align: baseline;
`;

export const StyledTriggerText = styled(TriggerText)`
  border: 0;
`;
